<template>
  <b-navbar toggleable="sm" class="header d-print-none">
      <b-modal ref="share-modal" size="lg" id="modal-center" centered title="Share Readonly Report" ok-only>
          <b>{{activeSite.url}}</b>
          <p class="my-4">Anyone with the following link can view this report:</p>
          <b-form-input type="text" :value="`${VUE_APP_DOMAIN_ROOT}${shareId}/dashboard`">
          </b-form-input>
          <a target="_blank" style="float:right;font-size:18px;padding:6px" title="Share on Twitter" :href="`https://twitter.com/intent/tweet?text=Audit+report+for+${activeSite.url}&url=${VUE_APP_DOMAIN_ROOT}${shareId}/dashboard&`"><i class="fa fa-twitter"></i></a>
      </b-modal>
   <a  @click="sidebar.expanded = !sidebar.expanded" class="d-block d-md-none"><span class="navbar-toggler-icon"></span></a>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav v-if="websites.length > 0">

          <div>
              <b-dropdown variant="primary"  id="dropdown-buttons" :text="activeSiteName | truncate(60)" class="m-2">
                  <b-dropdown-item-button v-for="website in websites" @click=selectSite(website)>{{website.url | truncate(60)}}</b-dropdown-item-button>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item  v-if="user.role === 'user'" :to="{ name: 'WebsitesPage'}">Show All</b-dropdown-item>
                  <b-dropdown-item  v-else>
                     <span><a href="https://app.pagewatch.dev/register" @click="goToPageWatch()">Sign up to check another site</a></span>
                  </b-dropdown-item>
              </b-dropdown>
          </div>

      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto" v-if="user.role === 'user'">
          <b-nav-item :to="{ name: 'NewPage'}" style="white-space:nowrap"><i class="fa fa-fw fa-plus"></i> New Site</b-nav-item>

          <b-nav-item v-if="$route.meta.customMenu !== 'account'" @click="share" style="white-space:nowrap"><i class="fa fa-fw fa-share-alt"></i> Share</b-nav-item>
        <b-nav-item-dropdown right style="white-space: nowrap;">
            <!-- Using 'button-content' slot -->
            <template slot="button-content"
            > <i class="fa fa-fw fa-cog"></i></template
            >
            <b-dropdown-text><span style="color:gray;padding:.25rem 1.5rem;margin-bottom:0">{{user.email}}</span></b-dropdown-text>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item  v-if="user.role === 'user'" :to="{ name: 'AccountsPage'}">My Account</b-dropdown-item>
            <b-dropdown-item  v-if="user.role === 'user'" :to="{ name: 'WebsitesPage'}">My Sites</b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="mailto:support@pagewatch.dev">Contact us</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>

            <b-dropdown-item @click="logout">Sign out</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-else-if="user.role === 'demo'">
            <b-nav-item href="https://app.pagewatch.dev/register" style="white-space:nowrap"><i class="fa fa-fw fa-plus"></i> Sign Up</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-else>
            <b-link href="https://app.pagewatch.dev/register" v-if="completedAt">Sign up to check another site</b-link>
        </b-navbar-nav>

    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import gql from "graphql-tag";
import axios from "axios";
import DemoNotice from "@/components/DemoNotice/DemoNotice";

export default {
  name: 'Header',
  components: {DemoNotice},
  computed: {
    ...mapState({activeSite: 'activeSite', user: 'user'}),
    location(){
      return document.location.href
    },
    activeSiteName(){
      if (this.$route.meta.customMenu === 'account'){
        return 'View Report'
      }
      return this.activeSite.url
    }
  },
  data() {
    return {
      userLoaded: false,
      VUE_APP_DOMAIN_ROOT: process.env.VUE_APP_DOMAIN_ROOT,
      shareId: '',
      websites: [],
      completedAt: ''
    };
  },
  apollo: {
    websites: {
      query(){ return gql`query {
      websites: websites_website(where: {deleted: {_eq: false}}, limit: 10, order_by: {id: desc}) {
        id
        url
        demo
        uuid
        websites_crawls(order_by: {completed_at: desc}, limit: 1){
            id
            completed_at
        }
      }
    }`
      },
      result(data, b){
        if (this.websites.length > 1){
          let demoIndex = this.websites.findIndex((w)=> { return w.demo; });
          if (demoIndex !== -1) {
            this.websites.splice(demoIndex, 1)
          }
        }
        if (data.data.websites[0]) {
          this.completedAt = data.data.websites[0].websites_crawls[0].completed_at;
        }
      }
    },
  },
  props: {
    sidebar: {
      expanded: Boolean
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    goToPageWatch(){
      document.location = 'https://pagewatch.dev';
    },
    selectSite(site){
      // this.$store.commit("setActiveSite", site);


      axios
        .put(`websites/active/${site.uuid}`)
        .then(
          response => {

            if (this.$route.meta.customMenu === 'account'){
              this.$router.push({ name: "Dashboard" });
            }
            return true;
          },
          _response => {
            console.warn(_response);
            return false;
          }
        );

    },
    share(){
      this.$refs['share-modal'].show();
      if (this.user.role === 'demo'){
        this.shareId =  window.location.pathname.split('/')[1]
        return;
      }
      this.shareId = this.activeSite.uuid;
      axios
        .post(`websites/share/${this.activeSite.uuid}`)
        .then(
          response => {
            this.shareId = response.data.data.id;
            return true;
          },
          _response => {
            console.warn(_response);
            return false;
          }
        );
    },
    logout() {
      if (this.$auth.isAuthenticated()) {
        this.$auth.logout();
      }
      this.$router.push('/login');
      window.location.reload(false);
    },
  },
  created() {

  },
  mounted(){
    this.$root.$on('websites-reload',  async() => {
      if (this.$apollo.queries.websites) {
        await this.$apollo.queries.websites.refetch();
      }
    });
  }
};
</script>

<style src="./Header.scss" lang="scss" scoped/>
